import Collection from '../collection/redis'
import Model from '../model'

// ===================================================================

export default class Token extends Model {}

// -------------------------------------------------------------------

export class Tokens extends Collection {}
